// DO NOT EDIT -- generated from fs/services/dx-objects/objectreferences.proto

import { DefinedEventDetail } from './definedevents.proto';
import { FunnelDetail } from './funnels.proto';
import { HeatmapDetail } from './heatmaps.proto';
import { JourneyDetail } from './journeys.proto';
import { MetricDetail } from './metrics.proto';
import { Dashboard } from './model.proto';
import { NamedElementDetail } from './namedelements.proto';
import { PageDetail } from './pages.proto';
import { RetentionMetricDetail } from './retentionmetrics.proto';
import { SegmentDetail } from './segments.proto';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export interface ObjectReferences {
  objectDetails: ObjectDetails[];
}

export interface ObjectDetails {
  objectId: string;
  objectType: string;
  /**
   * Deprecate the following fields in favor of the oneof dx_object.
   * 
   * @deprecated
   */
  objectName: string;
  /** @deprecated */
  createdBy: string;
  /** @deprecated */
  lastUpdated: protobuf.timestamp | null;
  /** @deprecated */
  archived: boolean;
  dashboard?: Dashboard | null;
  funnel?: FunnelDetail | null;
  metric?: MetricDetail | null;
  retentionMetric?: RetentionMetricDetail | null;
  segment?: SegmentDetail | null;
  heatmap?: HeatmapDetail | null;
  journey?: JourneyDetail | null;
  definedEvent?: DefinedEventDetail | null;
  namedElement?: NamedElementDetail | null;
  page?: PageDetail | null;
  specObjectMapping?: SpecObjectMappingRecordDetails | null;
  specPropertyMapping?: SpecPropertyMappingDetails | null;
  objectViewCount: protobuf.int64;
}

export namespace ObjectDetails {
  /** Send the entire object to the client to be used for rendering various features. */
  export enum dx_object {
    dashboard = 7,
    funnel = 8,
    metric = 9,
    retentionMetric = 10,
    segment = 11,
    heatmap = 12,
    journey = 13,
    definedEvent = 14,
    namedElement = 15,
    page = 16,
    specObjectMapping = 18,
    specPropertyMapping = 19
  }

  /** Send the entire object to the client to be used for rendering various features. */
  export function dx_object_oneof(m: ObjectDetails): { opt: dx_object.dashboard, val: Dashboard } | { opt: dx_object.definedEvent, val: DefinedEventDetail } | { opt: dx_object.funnel, val: FunnelDetail } | { opt: dx_object.heatmap, val: HeatmapDetail } | { opt: dx_object.journey, val: JourneyDetail } | { opt: dx_object.metric, val: MetricDetail } | { opt: dx_object.namedElement, val: NamedElementDetail } | { opt: dx_object.page, val: PageDetail } | { opt: dx_object.retentionMetric, val: RetentionMetricDetail } | { opt: dx_object.segment, val: SegmentDetail } | { opt: dx_object.specObjectMapping, val: SpecObjectMappingRecordDetails } | { opt: dx_object.specPropertyMapping, val: SpecPropertyMappingDetails } | null {
    if (m.dashboard != null) { return { opt: dx_object.dashboard, val: m.dashboard } }
    if (m.funnel != null) { return { opt: dx_object.funnel, val: m.funnel } }
    if (m.metric != null) { return { opt: dx_object.metric, val: m.metric } }
    if (m.retentionMetric != null) { return { opt: dx_object.retentionMetric, val: m.retentionMetric } }
    if (m.segment != null) { return { opt: dx_object.segment, val: m.segment } }
    if (m.heatmap != null) { return { opt: dx_object.heatmap, val: m.heatmap } }
    if (m.journey != null) { return { opt: dx_object.journey, val: m.journey } }
    if (m.definedEvent != null) { return { opt: dx_object.definedEvent, val: m.definedEvent } }
    if (m.namedElement != null) { return { opt: dx_object.namedElement, val: m.namedElement } }
    if (m.page != null) { return { opt: dx_object.page, val: m.page } }
    if (m.specObjectMapping != null) { return { opt: dx_object.specObjectMapping, val: m.specObjectMapping } }
    if (m.specPropertyMapping != null) { return { opt: dx_object.specPropertyMapping, val: m.specPropertyMapping } }
    return null;
  }
}

/**
 * This message is used to send the object mapping details for the spec object.
 * It preserves compatibility with a single spec object mapping record but truly represents up to N mappings for the same slug.
 * The metadata provided is merged metadata based on earliest created and latest updated.
 */
export interface SpecObjectMappingRecordDetails {
  mapping: SpecObjectMappingRecordDetails.Mapping | null;
  metadata: protoauditstore.AuditMetadata | null;
}

/**
 * This message is used to send the object mapping details for the spec object.
 * It preserves compatibility with a single spec object mapping record but truly represents up to N mappings for the same slug.
 * The metadata provided is merged metadata based on earliest created and latest updated.
 */
export namespace SpecObjectMappingRecordDetails {
  export interface Mapping {
    objectSlug: string;
  }
}

/**
 * This message is used to send the property mapping details for the spec property.
 * Note: the metadata is best effort based on parent object mappings -- properties themselves do not have metadata.
 */
export interface SpecPropertyMappingDetails {
  mapping: SpecPropertyMappingDetails.Mapping | null;
  metadata: protoauditstore.AuditMetadata | null;
}

/**
 * This message is used to send the property mapping details for the spec property.
 * Note: the metadata is best effort based on parent object mappings -- properties themselves do not have metadata.
 */
export namespace SpecPropertyMappingDetails {
  export interface Mapping {
    propertySlug: string;
  }
}
